import { render } from "./ForgotPassword2Body.vue?vue&type=template&id=48453b7c&scoped=true"
import script from "./ForgotPassword2Body.vue?vue&type=script&lang=js"
export * from "./ForgotPassword2Body.vue?vue&type=script&lang=js"

import "./ForgotPassword2Body.vue?vue&type=style&index=0&id=48453b7c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48453b7c"]])

export default __exports__